import mock from './mock';
import './auth/Account';

mock.onAny().passThrough();
